import FeaturePageTemplate from "@/components/FeaturePageTemplate";

export default function AiMissedCallPage() {
  return (
    <FeaturePageTemplate
      slug="missed-call"
      accent="#EA580C"
      badge="Recover lost revenue · Now available"
      title="Missed-Call Recovery"
      tagline="Never lose a missed call to voicemail again"
      subtitle="When a call is missed, we automatically send an SMS or WhatsApp with a callback link. Configurable per-tenant template, quiet hours, and max attempts. Every missed call becomes an LCC contact and activity — no lead falls through the cracks."
      primaryCta={{ label: "Open Recovery Console", to: "/missed-calls" }}
      secondaryCta={{ label: "Configure your voice rep", to: "/voice" }}
      brandStripe="Twilio-compatible webhook. Sent.dm compatible SMS. Quiet-hours-safe by default."
      flow={[
        { n: "1", title: "Miss",     desc: "Your line rings, no one picks up. Webhook fires within seconds." },
        { n: "2", title: "Match",    desc: "Caller number matched to an existing LCC contact (or a new one is created)." },
        { n: "3", title: "Send",     desc: "Auto SMS/WhatsApp with your template + callback link, respecting quiet hours." },
        { n: "4", title: "Track",    desc: "Delivery status, click, and reply captured on the recovery console." },
        { n: "5", title: "Close",    desc: "One-click 'Mark recovered' once the customer is helped." },
      ]}
      capabilities={[
        { icon: "PhoneMissed", title: "Instant auto-response",   desc: "SMS or WhatsApp fires within seconds of a missed call." },
        { icon: "MessageSquare", title: "Custom template",       desc: "Merge fields: {name}, {business}, {callback_link}, {reason}." },
        { icon: "Moon",        title: "Quiet hours + throttle", desc: "No 2am pings. Configurable per tenant with timezone awareness." },
        { icon: "Users",       title: "LCC integration",         desc: "Every missed call emits a contact + activity for the shared customer memory." },
        { icon: "BarChart3",   title: "Recovery analytics",      desc: "Delivery rate, response rate, and revenue-recovered dashboards." },
        { icon: "Settings",    title: "Per-tenant policy",       desc: "Max attempts, delay before send, and campaign-specific templates." },
      ]}
      safetyBullets={[
        ["Quiet-hours safe",     "No SMS goes out outside configured business hours."],
        ["Max attempts cap",     "Never spams a customer — configurable per tenant."],
        ["Consent scope",        "Respects customer opt-out on marketing channels."],
        ["Full delivery log",    "Every SMS attempt is logged with delivery status and reply."],
      ]}
      closingHeadline="Every missed call is a second chance."
      closingSubtitle="Set it up once. Recover leads on autopilot."
      testIdPrefix="ai-missed-call-page"
    />
  );
}
